import type { ReactNode } from "react";
import * as AvatarPrimitive from "@radix-ui/react-avatar";
import { cn } from "../../../lib/utils";

interface AvatarProps {
  src?: string;
  alt?: string;
  fallback?: ReactNode;
  delayMs?: number;
  rounded?: boolean;
  objectFit?: "cover" | "contain";
  className?: string;
  imageClassName?: string;
  fallbackClassName?: string;
}

export const Avatar = ({
  src,
  alt = "",
  fallback,
  delayMs,
  rounded = true,
  objectFit = "cover",
  className = "",
  imageClassName = "",
  fallbackClassName = "",
}: AvatarProps) => {
  const roundedClass = rounded ? "rounded-full" : "";

  return (
    <AvatarPrimitive.Root
      className={`relative flex h-full w-full shrink-0 overflow-hidden ${roundedClass} ${className}`.trim()}
    >
      <AvatarPrimitive.Image
        src={src}
        alt={alt}
        className={cn(
          "aspect-square h-full w-full",
          objectFit === "contain" ? "object-contain" : "object-cover",
          imageClassName,
        )}
      />
      <AvatarPrimitive.Fallback
        delayMs={delayMs}
        className={`flex h-full w-full items-center justify-center ${roundedClass} bg-global-overlay-secondary text-global-secondary text-size-sm font-medium ${fallbackClassName}`.trim()}
      >
        {fallback}
      </AvatarPrimitive.Fallback>
    </AvatarPrimitive.Root>
  );
};
